var _ = require('underscore');
var sw = require('./../sw');
var tracking = require('./index');

(function(mixpanel) {
  if (!mixpanel) {
    return;
  }


  // Super properties
  if (sw.data.mixpanelSuperProperties) {
    mixpanel.register(sw.data.mixpanelSuperProperties);
  }

  // Extract last touch UTM params. Code from here: https://mixpanel.com/blog/2015/05/11/community-tip-last-touch-utm-tags
  var getQueryParam = function(url, param) {
    // Expects a raw URL
    param = param.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regexS = "[\\?&]" + param + "=([^&#]*)",
    regex = new RegExp( regexS ),
    results = regex.exec(url);
    if (results === null || (results && typeof(results[1]) !== 'string' && results[1].length)) {
      return '';
    } else {
      return decodeURIComponent(results[1]).replace(/\+/g, ' ');
    }
  };

  var campaignParams = function() {
    var campaign_keywords = 'utm_source utm_medium utm_campaign utm_content utm_term'.split(' '),
        kw = '',
        params = {},
        first_params = {};

    var index;
    for (index = 0; index < campaign_keywords.length; ++index) {
      kw = getQueryParam(document.URL, campaign_keywords[index]);
      if (kw.length) {
        params[campaign_keywords[index] + ' [last touch]'] = kw;
      }
    }
    for (index = 0; index < campaign_keywords.length; ++index) {
      kw = getQueryParam(document.URL, campaign_keywords[index]);
      if (kw.length) {
        first_params[campaign_keywords[index] + ' [first touch]'] = kw;
      }
    }
    mixpanel.register(params);
  };

  campaignParams();

  // Fire off load events
  sw.data.loadEvents = sw.data.loadEvents || [];

  _.each(sw.data.loadEvents, function(eventData) {

    var data = {};
    if (eventData.spin) {
      var pt = tracking.ProductTracking(eventData.spin);
      data = pt.getEventAddToCartData(eventData);
    }

    data = _.extend(data || {}, eventData.data);

    var services = eventData.trackingServices || ['mixpanel'];
    var options = {trackingServices: services};

    if(sw.data.pageIdentifier === 'single-product-embed'){
      data.embed_uri = window.location.toString();
    }

    sw.track(eventData.eventName, data, options);
  });

})(window.mixpanel);
